import type { ReactNode } from 'react';
import { MapLayout } from '../layouts/MapLayout';

export type MapTemplateProps = {
  /** The view SegmentedControl (Cards / Map) and the count. */
  toolbar?: ReactNode;
  /** ListRows synced with the map on hover and selection. */
  list: ReactNode;
  /** The muted basemap with MapPins and MapClusters; the selected pin opens a JobCard callout. */
  map: ReactNode;
  /** Accessible name of the phone sheet handle. */
  handleLabel: string;
  className?: string;
};

/** The map view of a search: list beside a muted map; on phones the list is a draggable sheet over the map. */
export function MapTemplate({ toolbar, list, map, handleLabel, className }: MapTemplateProps) {
  return <MapLayout toolbar={toolbar} list={list} map={map} handleLabel={handleLabel} className={className} />;
}
